/**
 * @constant COST_TYPES
 * @description options for base price type
 * @see apps/application/models/orm/TblItemPeer.php
 */
const COST_TYPES = [
    { id: 1, label: "Fixed" },
    { id: 2, label: "% of latest cost (excluding $0)" },
    { id: 3, label: "% of average cost (excluding $0)" },
    { id: 4, label: "% of highest cost" },
    { id: 5, label: "% of lowest cost (excluding $0)" }
];

/**
 * @constant UNIT_COST_LABEL
 * @description unit cost label based on price type
 */
const UNIT_COST_LABEL = {
    1: "based on highest cost", // COST_TYPE_FIXED
    2: "based on latest cost", // COST_TYPE_LAST_COST
    3: "based on average cost", // COST_TYPE_AVERAGE_COST
    4: "based on of highest cost", // COST_TYPE_HIGHEST_COST
    5: "based on lowest cost" // COST_TYPE_LOWEST_COST
};

/**
 * @constant MINIMUM_PRICE_TYPE_OPTIONS
 * @constant COST_TYPE_FIXED
 * @see apps/application/models/orm/TblItemPeer.php
 */
const MINIMUM_PRICE_TYPE_OPTIONS = [
    { id: 1, label: "Per Item Total" },
    { id: 2, label: "Per Unit" }
];
const COST_TYPE_FIXED = 1;
const COST_TYPE_LAST_COST = 2;
const COST_TYPE_AVERAGE_COST = 3;
const COST_TYPE_HIGHEST_COST = 4;
const COST_TYPE_LOWEST_COST = 5;

/**
 * @constant CLASS_SERVICE
 * @see apps/application/models/orm/TblItemClassPeer.php
 */
const CLASS_SERVICE = 2;

/**
 * @constant ITEM_PEER
 * @see application/models/orm/TblItemPeer.php
 */
const TYPE_FEE = 11;
const TYPE_OUTPATIENT = 5;
const TYPE_DISCOUNT = 12;
const TYPE_LAB = 7;

/**
 * @constant TEMPLATE_ELEMENT
 * @see application/models/orm/TblTemplateElementPeer.php
 */
const TEMPLATE_ELEMENT_TYPE_BUNDLE = 1;

import ItemServices from "@/services/items";
import { forEach, sortBy } from "lodash";

/**
 * @name ItemMixin
 * @description Mixin used within item components
 */
export default {
    data() {
        return {
            MINIMUM_PRICE_TYPE_OPTIONS: MINIMUM_PRICE_TYPE_OPTIONS,
            COST_TYPE_FIXED: COST_TYPE_FIXED,
            COST_TYPES: COST_TYPES,
            CLASS_SERVICE: CLASS_SERVICE,
            TYPE_FEE: TYPE_FEE,
            TYPE_OUTPATIENT: TYPE_OUTPATIENT,
            TYPE_DISCOUNT: TYPE_DISCOUNT,
            TYPE_LAB: TYPE_LAB,
            feesOptions: [],
            concentrationUoms: [],
            itemUoms: [],
            duesOptions: [],
            itemServiceLoading: {
                fees: false,
                due: false,
                itemuom: false,
                concentrationuom: false
            }
        };
    },
    computed: {},
    methods: {
        getConcentrationUOM() {
            let self = this;
            let uoms = [];
            self.itemServiceLoading.concentrationuom = true;
            self.concentrationUoms = [];
            ItemServices.getMasterUOM().then(res => {
                self.itemServiceLoading.concentrationuom = false;
                forEach(res, function (uom, key) {
                    uoms.push({
                        id: key,
                        label: uom,
                        labelLowercase: uom.toLowerCase() // for sorting only
                    });
                });
                self.concentrationUoms = sortBy(uoms, "labelLowercase");
            });
        },
        getItemUOM() {
            let self = this;
            let uoms = [];
            self.itemServiceLoading.itemuom = true;
            self.itemUoms = [];
            ItemServices.getMasterUOM({
                module: 1
            }).then(res => {
                self.itemServiceLoading.itemuom = false;
                forEach(res, function (uom, key) {
                    uoms.push({
                        id: key,
                        label: uom,
                        labelLowercase: uom.toLowerCase() // for sorting only
                    });
                });
                self.itemUoms = sortBy(uoms, "labelLowercase");
            });
        },
        getDuesOptions() {
            let self = this;
            self.itemServiceLoading.due = true;
            self.duesOptions = [{ id: "0", name: "None" }];
            ItemServices.getDuesOptions().then(res => {
                self.itemServiceLoading.due = false;
                self.duesOptions = self.duesOptions.concat(res);
            });
        },
        _getUnitCost(item) {
            if (_.isEmpty(item.unit_cost)) {
                return "N/A: No cost data in Purchases";
            } else if (item.unit_cost && item.cost_type_id > 0) {
                return (
                    this._toCurrency(item.unit_cost, true) +
                    "/ " +
                    (item.itemUom ? item.itemUom.label : "") +
                    " (" +
                    UNIT_COST_LABEL[item.cost_type_id] +
                    ")"
                );
            }

            return "";
        },
        getItemTotal(item) {
            let totalString = "";
            if (item) {
                const totalPrice = this._toNumber(item.total_price, 2, false);
                const maxTotalPrice = this._toNumber(
                    item.max_total_price,
                    2,
                    false
                );

                totalString = this._toCurrency(totalPrice);

                if (
                    maxTotalPrice != 0 &&
                    totalPrice != maxTotalPrice &&
                    (item.max_quantity > 0 ||
                        item.type === TEMPLATE_ELEMENT_TYPE_BUNDLE)
                ) {
                    totalString = `${totalString} - ${this._toCurrency(
                        maxTotalPrice
                    )}`;
                }
            }
            return totalString;
        }
    }
};
